import { Link } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { lastUpdateQuery } from "@/lib/queries";
import { formatDate } from "@/lib/format";
import { Brand } from "@/components/brand";
import { ContactDialog } from "@/components/contact-dialog";
import "@/i18n";

export function SiteFooter() {
  const { t, i18n } = useTranslation();
  const { data: lastUpdate } = useQuery(lastUpdateQuery);
  return (
    <footer className="border-t border-ink/8 mt-24">
      <div className="max-w-7xl mx-auto px-6 py-10 flex flex-col gap-6">
        {/* Top line: brand on the left, navigation on the right. */}
        <div className="flex flex-col items-center gap-5 md:flex-row md:items-center md:justify-between md:gap-8">
          <Brand size="sm" />
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-3 md:justify-end md:gap-8 text-mono-caps text-ink/40">
            <Link to="/" className="hover:text-ink transition-colors">{t("nav.atlas")}</Link>
            <Link to="/youtubers" className="hover:text-ink transition-colors">{t("nav.explorers")}</Link>
            <Link to="/videos" className="hover:text-ink transition-colors">{t("nav.search")}</Link>
            <Link to="/countries" className="hover:text-ink transition-colors">{t("nav.countries")}</Link>
            <Link to="/about" className="hover:text-ink transition-colors">{t("nav.about")}</Link>
            <ContactDialog
              trigger={
                <button type="button" className="text-mono-caps hover:text-ink transition-colors">
                  {t("contact.cta")}
                </button>
              }
            />
          </div>
        </div>
        {/* Bottom line: legal notice and freshness stamp. */}
        <div className="flex flex-col items-center gap-2 text-center md:flex-row md:items-center md:justify-between md:gap-4 md:text-left">
          <span className="text-mono-caps text-ink/40 leading-relaxed">
            © {new Date().getFullYear()} · {t("footer.tagline")}
          </span>
          {lastUpdate && (
            <span className="text-mono-caps text-ink/40">
              {t("footer.lastUpdate", { date: formatDate(lastUpdate, i18n.language) })}
            </span>
          )}
        </div>
      </div>
    </footer>
  );
}
